(function determineLoadTime() {
    const startTime = Date.now();

    window.addEventListener('load', function () {
        const endTime = Date.now();
        console.log('Document load time: ' + (endTime - startTime) / 1000 + ' seconds');
    });
})();
